import { Refresh } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";

export default function RefreshButton({ loading, onClick }) {
    const [cooldown, setCooldown] = useState(false);

    const handleClick = () => {
        if (cooldown) return;
        onClick();
        setCooldown(true);
        setTimeout(() => setCooldown(false), 3000); 
    };

    return (
        <Tooltip title="Refresh Data">
            <IconButton
                onClick={handleClick}
                color="primary"
                disabled={loading || cooldown}
                sx={{
                    bgcolor: "rgba(25, 118, 210, 0.08)",
                    "&:hover": {
                        bgcolor: "rgba(25, 118, 210, 0.15)",
                    },
                }}
            >
                {loading ? <CircularProgress size={24} /> : <Refresh />}
            </IconButton>
        </Tooltip>
    );
}
